exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-20[data-v-5459af6a]{width:20%}.table-wrap[data-v-5459af6a]{height:calc(100% - 290px)}", ""]);

// exports
